if (!customElements.get('search-ingredient')) {
  class SearchIngredient extends HTMLElement {
    constructor() {
      super();

      this.allIngredients = JSON.parse(this.dataset.allIngredients) || [];
      this.searchInput = this.querySelector('input[type="search"]');
      this.searchResults = this.querySelector('[data-ingredient-results]');
      this.clearButton = this.querySelector('button[type="reset"]');

      this.isOpen = false;

      if (!this.allIngredients.length || !this.searchInput || !this.searchResults || !this.clearButton) {
        return;
      }

      this.init();
    }

    displayResults(results, searchTerm) {
      this.searchResults.innerHTML = '';
      
      this.showResults();

      if (!results.length) {
        this.searchResults.innerHTML = `<p class="ingredient-result__no-results-message">${window.FoxTheme.strings.noFoundResultsFor} <bold>"${searchTerm}"</bold></p>`;
        return;
      }

      results.forEach(ingredient => {
        const resultItem = document.createElement('div');
        resultItem.classList.add('ingredient-result');
        resultItem.innerHTML = `
          <a class="ingredient-result-item" href="/pages/${ingredient.link}">
            <img class="ingredient-result-image" src="${ingredient.image_src}" alt="${ingredient.title}" />
            <span class="ingredient-result-title">${ingredient.title}</span>
          </a>`;
        this.searchResults.appendChild(resultItem);
      });
    }

    clearResults() {
      this.searchResults.innerHTML = '';
      this.searchResults.setAttribute('hidden', '');
    }

    hideResults() {
      this.searchResults.setAttribute('hidden', '');
      this.isOpen = false;
    }

    showResults() {
      this.searchResults.removeAttribute('hidden');
      this.isOpen = true;
    }

    init() {
      this.searchInput.addEventListener('focus', () => {
        if (this.searchInput.value.length >= 2) {
          this.showResults();
        }
      });

      this.searchInput.addEventListener('input', (event) => {
        const searchTerm = event.target.value.toLowerCase();

        if (searchTerm.length >= 2) {
          const results = this.allIngredients.filter(ingredient => {
            return ingredient.title.toLowerCase().includes(searchTerm);
          });

          return this.displayResults(results, searchTerm);
        }

        this.clearResults();
      })

      this.clearButton.addEventListener('click', () => {
        this.searchInput.value = '';
        this.clearResults();
      });

      document.addEventListener('click', (event) => {
        if (this.contains(event.target)) {
          return;
        }
      
        if (this.isOpen) {
          this.hideResults();
        }
      });
    }
  }
  customElements.define('search-ingredient', SearchIngredient);
}
